<template>
  <div>
    <!-- 提报人信息 -->
    <div class="trade-order-block">
      <div class="block-title">提报人信息</div>
      <div class="block-content">
        <el-row class="content-row">
          <!-- 提报人 -->
          <el-col :span="3">提报人</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.applyClientLevelName || '' }} - {{ tradeApplyInfoVO.applyClientName }}</el-col>

          <!-- 所属区域 -->
          <el-col :span="3">所属区域</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.applyClientRegionName }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3" v-if="tradeApplyInfoVO.applyParentClientName">提报人上级</el-col>
          <el-col
            :span="9"
            v-if="tradeApplyInfoVO.applyParentClientName"
          >{{tradeApplyInfoVO.applyParentClientLevel}} - {{ tradeApplyInfoVO.applyParentClientName}}</el-col>
        </el-row>
      </div>
    </div>

    <!-- 门店基本信息 -->
    <div class="trade-order-block">
      <div class="block-title">门店基本信息</div>
      <!-- 门店基本信息 店招类 -->
      <!-- <div class="block-content" v-if="tradeApplyOrderVO && (tradeApplyOrderVO.applyType === '01' || tradeApplyOrderVO.applyType === '03')">
        <el-row class="content-row">
          <el-col :span="3">门店名称</el-col>
          <el-col :span="9">{{ tradeApplyBaseVO.pocName }}</el-col>
          <el-col :span="3" v-show="tradeApplyOrderVO.tradeApplyExecCustom || tradeApplyOrderVO.tradeApplyExecCooler">子渠道</el-col>
          <el-col
            :span="9"
            v-show="tradeApplyOrderVO.tradeApplyExecCustom || tradeApplyOrderVO.tradeApplyExecCooler"
          >{{ tradeApplyInfoVO.subChannelName }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">门头照</el-col>
          <el-col :span="9" v-viewer="{movable: true}" class="info-img">
            <img :src="getImg(tradeApplyBaseVO.pocOutsidePhotoUri)" />
          </el-col>
          <el-col :span="3">营业执照</el-col>
          <el-col :span="9" v-if="tradeApplyBaseVO.bizLicensePhotoUri" class="info-img" v-viewer="{movable: true}">
            <img :src="getImg(tradeApplyBaseVO.bizLicensePhotoUri)" />
          </el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">补充资料</el-col>
          <el-col :span="21" v-viewer="{movable: true}" class="info-img">
            <div class="img-wrapper" v-for="img in tradeApplyBaseVO.pocImageList" :key="img.pocImageId">
              <img :src="getImg(img.imageUri)" />
            </div>
          </el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3" v-show="tradeApplyOrderVO.tradeApplyExecCustom || tradeApplyOrderVO.tradeApplyExecCooler">业务线</el-col>
          <el-col
            :span="9"
            v-show="tradeApplyOrderVO.tradeApplyExecCustom || tradeApplyOrderVO.tradeApplyExecCooler"
          >{{ setClientType(tradeApplyInfoVO.clientType)}}</el-col>
          <el-col :span="3">渠道</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.channelName }}</el-col>
          <el-col :span="3" v-show="!(tradeApplyOrderVO.tradeApplyExecCustom || tradeApplyOrderVO.tradeApplyExecCooler)">子渠道</el-col>
          <el-col
            :span="9"
            v-show="!(tradeApplyOrderVO.tradeApplyExecCustom || tradeApplyOrderVO.tradeApplyExecCooler)"
          >{{ tradeApplyInfoVO.subChannelName }}</el-col>
        </el-row>
        <el-row class="content-row" v-if="tradeApplyBaseVO.businessChannelName">
          <el-col :span="3">业务渠道</el-col>
          <el-col :span="9">{{ tradeApplyBaseVO.businessChannelName }}</el-col>
        </el-row>
        <el-row class="content-row" v-if="tradeApplyBaseVO.contactPhone">
          <el-col :span="3">联系人</el-col>
          <el-col :span="9">{{ tradeApplyBaseVO.contactPerson }}</el-col>
          <el-col :span="3">联系电话</el-col>
          <el-col :span="9">{{ tradeApplyBaseVO.contactPhone }}</el-col>
        </el-row>
        <el-row class="content-row" v-if="tradeApplyBaseVO.keyContactPhone">
          <el-col :span="3">{{ applyTypeName }}执行人</el-col>
          <el-col :span="9">{{ tradeApplyBaseVO.keyContactPerson }}</el-col>
          <el-col :span="3">{{ applyTypeName }}执行人电话</el-col>
          <el-col :span="9">{{ tradeApplyBaseVO.keyContactPhone }}</el-col>
        </el-row>
        <el-row class="content-row" v-if="tradeApplyOrderVO.tradeApplyExecPerfectVOList">
          <el-col :span="3">一批经销商名称</el-col>
          <el-col :span="9">{{ tradeApplyBaseVO.wsL1Name }}</el-col>
        </el-row>
        <el-row class="content-row" v-if="tradeApplyBaseVO.secondContactPerson">
          <el-col :span="3">备用联系人</el-col>
          <el-col :span="9">{{ tradeApplyBaseVO.secondContactPerson }}</el-col>
          <el-col :span="3">备用联系电话</el-col>
          <el-col :span="9">{{ tradeApplyBaseVO.secondContactPhone }}</el-col>
        </el-row>
        <el-row class="content-row" v-if="!tradeApplyOrderVO.tradeApplyExecPerfectVOList">
          <el-col :span="3">销售联系人</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.salesContactPerson }}</el-col>
          <el-col :span="3">销售联系电话</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.salesContactPhone }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">门店地址</el-col>
          <el-col
            :span="9"
          >{{ tradeApplyBaseVO.provinceName || '' }}{{ tradeApplyBaseVO.cityName || ''}}{{tradeApplyBaseVO.countyName || ''}}{{ tradeApplyBaseVO.detailAddress || ''}}</el-col>
          <el-col :span="3" v-if="tradeApplyOrderVO.tradeApplyExecPerfectVOList">WCCSID</el-col>
          <el-col :span="9" v-if="tradeApplyOrderVO.tradeApplyExecPerfectVOList">{{ tradeApplyBaseVO.wccsId }}</el-col>
        </el-row>
      </div>-->
      <div class="block-content" v-if="tradeApplyOrderVO && (tradeApplyOrderVO.applyType === '01' || tradeApplyOrderVO.applyType === '03')">
        <el-row class="content-row">
          <BaseCell :value="basePocInfo.pocName" label="门店名称" />
          <BaseCell :value="basePocInfo.abiOneId" label="IGnite ID" />
        </el-row>
        <el-row class="content-row" v-if="isPerfect">
          <BaseCell :value="String(basePocInfo.beesPocFlag) === '1' ? '交易门店' : '非交易门店'" label="门店类型" />
        </el-row>

        <el-row class="content-row">
          <BaseCell :value="basePocInfo.channelName" label="门店渠道" />
          <BaseCell :value="basePocInfo.abiChannelFormat" label="渠道业态" />
        </el-row>
        <el-row class="content-row">
          <BaseCell :value="basePocInfo.pocLocalName" label="地理位置" v-if="isCoolerCustom" />
          <BaseCell :value="tradeApplyBaseVO.businessChannelCodeName" label="业务渠道" v-if="isPerfect" />
          <BaseCell :value="basePocInfo.businessChannelName" label="业务渠道" v-else />
        </el-row>
        <el-row class="content-row" v-if="isCoolerCustom">
          <BaseCell :value="basePocInfo.pocAreaName" label="门店特征" />
          <BaseCell :value="basePocInfo.averageFee" label="人均消费" numberFormat valueUnit="元" />
        </el-row>
        <el-row class="content-row">
          <BaseCell
            :value="`${tradeApplyBaseVO.wccsId || '暂无'}  ${tradeApplyBaseVO.wccsWsName ? (tradeApplyBaseVO.wccsWsName) : ''}`"
            label="WCCSID"
          />
          <BaseCell :value="isPbo" label="是否ABI买店" />
        </el-row>
        <el-row class="content-row">
          <BaseCell :value="tradeApplyBaseVO.beesWsL1Name" label="经销商信息" v-if="isPerfect && String(basePocInfo.beesPocFlag) === '1'" />
          <BaseCell :value="tradeApplyBaseVO.wsL1Name" label="经销商信息" v-if="isPerfect && String(basePocInfo.beesPocFlag) === '0'" />
          <BaseCell :value="basePocInfo.wccsSalesPotentialCode2022VersionName" label="销售潜力" />
        </el-row>
        <el-row class="content-row" v-if="isPerfect && String(basePocInfo.beesPocFlag) !== '1'">
          <BaseCell :value="tradeApplyBaseVO.keyContactPerson" :label="`执行人姓名`" />
          <BaseCell :value="tradeApplyBaseVO.keyContactPhone" :label="`执行人电话`" />
        </el-row>
        <el-row class="content-row" v-if="applyTypeName && execTypeSub !== '108' && execTypeSub !== '109'">
          <BaseCell v-if="String(basePocInfo.beesPocFlag) === '1'" :value="basePocInfo.beesWsL1Name" label="一批经销商名称" />
          <BaseCell v-else :value="basePocInfo.wsL1Name" label="一批经销商名称" />
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">门头照</el-col>
          <el-col :span="21" v-viewer="{movable: true}" class="info-img">
            <!-- 未开业-->
            <img
              v-if="basePocInfo.abiValidationStatus == 0 && basePocInfo.abiValidationType == 3"
              mode="aspectFit"
              class="detail-row-img"
              src="@/assets/images/poc_photo_default.png"
            />
            <img
              v-else-if="basePocInfo.pocOutsidePhotoUri"
              mode="aspectFill"
              class="detail-row-img"
              :src="getImg(basePocInfo.pocOutsidePhotoUri)"
            />
            <div v-else>暂无</div>
          </el-col>
        </el-row>
        <el-row class="content-row" v-if="isCoolerCustom">
          <el-col :span="3">门店照片</el-col>
          <el-col :span="21" v-viewer="{movable: true}" class="info-img">
            <div v-if="pocImageList.length">
              <div class="img-wrapper" v-for="img in pocImageList" :key="img.title">
                <img :src="getImg(img.imageUri)" />
                <div class="img-wrapper-title">{{ img.title }}</div>
              </div>
            </div>
            <div v-else>暂无</div>
          </el-col>
        </el-row>
        <el-row class="content-row" v-if="execTypeSub !== '108'">
          <!-- <BaseCell :value="getImg(basePocInfo.bizLicensePhotoUri)" label="营业执照" isImg /> -->
          <el-col :span="3">营业执照</el-col>
          <el-col :span="21" v-viewer="{movable: true}" class="info-img">
            <!-- 已验证 -->
            <template v-if="basePocInfo.abiValidationStatus == 1">
              <img
                class="detail-row-img"
                v-if="basePocInfo.bizLicensePhotoUri"
                mode="aspectFill"
                :src="getImg(basePocInfo.bizLicensePhotoUri)"
              />
              <!-- full -->
              <div
                v-else-if="basePocInfo.abiValidationType == 3 && basePocInfo.businessLicensePicNotReason"
              >{{ basePocInfo.businessLicensePicNotReason || '暂无' }}</div>
              <!-- basic -->
              <div v-else>暂无</div>
            </template>
            <!-- 未开业 -->
            <div v-else>暂无</div>
          </el-col>
        </el-row>
        <el-row class="content-row" v-if="execTypeSub !== '108'">
          <el-col :span="3">补充资料</el-col>
          <el-col :span="21" v-viewer="{movable: true}" class="info-img">
            <div v-if="basePocInfo.pocImageList && basePocInfo.pocImageList.length">
              <div class="img-wrapper" v-for="img in basePocInfo.pocImageList" :key="img.pocImageId">
                <img :src="getImg(img.imageUri)" />
              </div>
            </div>
            <div v-else>暂无</div>
          </el-col>
        </el-row>
        <el-row class="content-row">
          <BaseCell
            :value="`${basePocInfo.provinceName || ''} ${basePocInfo.cityName || ''} ${basePocInfo.countyName || ''} ${basePocInfo.detailAddress || ''}`"
            label="门店地址"
            allCell
          />
        </el-row>
      </div>
      <!-- 门店基本信息 pbo-->
      <div v-if="tradeApplyOrderVO && tradeApplyOrderVO.applyType === '04'">
        <div v-for="item in tradeApplyOrderVO.tradeApplyExecPboDTO.tradePboCirclePocList" :key="item.pboPocId">
          <div class="block-content" v-if="item.pocType === 'main'">
            <el-row class="content-row">
              <el-col :span="3">BUD Circle ID</el-col>
              <el-col :span="9">{{ item.circlePocId }}</el-col>
              <el-col :span="3">门店名称</el-col>
              <el-col :span="9">{{ item.circlePocName }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">联系人</el-col>
              <el-col :span="9">{{ item.circleContactPerson }}</el-col>
              <el-col :span="3">联系电话</el-col>
              <el-col :span="9">{{ item.circleContactPhone }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">业务员</el-col>
              <el-col :span="9">{{ item.circleSalesName }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">一批经销商名称</el-col>
              <el-col :span="9">{{ item.firstAgency }}</el-col>
              <el-col :span="3">二批经销商名称</el-col>
              <el-col :span="9">{{ item.secondAgency }}</el-col>
            </el-row>
            <el-row class="content-row">
              <el-col :span="3">门店地址</el-col>
              <el-col :span="21">{{ item.circlePocAddress }}</el-col>
            </el-row>
          </div>
          <div class="block-content" v-else>
            <el-row class="content-row">
              <el-col :span="3">分店ID</el-col>
              <el-col :span="9">{{ item.circlePocId }}</el-col>
              <el-col :span="3">分店名称</el-col>
              <el-col :span="9">{{ item.circlePocName }}</el-col>
            </el-row>
          </div>
          <div class="block-content" v-if="item.circlePocImage">
            <el-row class="content-row">
              <el-col :span="3">门店照片</el-col>
              <el-col :span="9" v-viewer="{movable: true}" class="info-img">
                <img :src="item.circlePocImage" alt style="width:200px" />
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="block-content">
        <el-row class="content-row">
          <div id="content-map"></div>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'
import BaseCell from '@/components/base-cell'
export default {
  name: 'store-base-info',
  components: {
    BaseCell
  },
  props: {
    tradeApplyOrderVO: {},
    tradeApplyInfoVO: {},
    basePocInfo: {},
    tradeApplyBaseVO: {},
    applyTypeName: {
      type: String,
      default: ''
    },
    tradeApplyExecVO: {}
  },
  data () {
    return {
      pocImageList: []
    }
  },
  computed: {
    isPbo () {
      if (this.basePocInfo.isPbo === null) return this.basePocInfo.isPbo
      return this.basePocInfo.isPbo ? '是' : '否'
    },

    execTypeSub () {
      if (this.tradeApplyExecVO) {
        return this.tradeApplyExecVO?.execTypeSub
      }
      return ''
    },

    isCoolerCustom () {
      return !!(this.tradeApplyOrderVO.tradeApplyExecCooler || this.tradeApplyOrderVO.tradeApplyExecCustom)
    },

    isPerfect () {
      if (this.tradeApplyOrderVO.tradeApplyExecPerfectVOList && this.tradeApplyOrderVO.tradeApplyExecPerfectVOList.length) {
        return true
      }
      return false
    }
  },
  created () {
  },
  methods: {
    initMap (info) {
      this.pocImageList = []
      // 售点照片
      // if (this.basePocInfo.pocOutsidePhotoUri) {
      //   this.pocImageList.push({ title: '门头照', imageUri: info.pocOutsidePhotoUri })
      // }
      if (this.basePocInfo.pocExternalPhotoUri && this.execTypeSub !== '108') {
        this.pocImageList.push({ title: '外部整体', imageUri: info.pocExternalPhotoUri })
      }
      if (this.basePocInfo.pocInsidePhotoUri && this.execTypeSub !== '108') {
        this.pocImageList.push({ title: '内部整体', imageUri: info.pocInsidePhotoUri })
      }
      if (this.basePocInfo.pocStreetPhotoUri && this.execTypeSub !== '108') {
        this.pocImageList.push({ title: '外部街区', imageUri: info.pocStreetPhotoUri })
      }

      const { locLatitude, locLongitude, pocName } = info
      if (!locLatitude || !locLongitude) return
      const map = new AMap.Map('content-map', {
        center: [locLongitude, locLatitude],
        zoom: 16
      })
      const position = new AMap.LngLat(locLongitude, locLatitude)
      const marker = new AMap.Marker({position, map})
      const handleMapClick = AMap.Event.addListener(map, 'click', () => {
        window.open(`https://uri.amap.com/marker?position=${locLongitude},${locLatitude}&name=${pocName}&src=尊享先锋订单平台`)
      })
    },

    setClientType (val) {
      if (val === '01') return 'TMKT'
      if (val === '02') return 'ISP'
      if (val === '03') return 'KA'
      return ''
    },

    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    }
  }
}
</script>

<style lang="scss" scoped>
#content-map {
  width: 450px;
  height: 200px;
  border-radius: 8px;
  cursor: pointer;
}

.info-img {
  img {
    width: 200px;
    height: 130px;
    object-fit: cover;
    border-radius: 8px;
    cursor: pointer;
  }
}
.img-wrapper {
  display: inline-block;
  padding-right: 10px;
}
</style>
